<ng-container *ngIf="step !== 3 else sendedTemplate">
    <div class="p-daten-wrapper">
        <div [class.left-section]="!mobileMode" [class.left-section-mobile]="mobileMode">
            <div class="p-daten-header">
                <clever-offerpackdetailheader [step]="step" (sendStep)="updateStep($event)">
                </clever-offerpackdetailheader>
            </div>
            <ng-container *ngIf="step === 2; else kundedaten">
                <div class="contact-wrapper-1 head-w">
                    <span multilang class="head-title">Bitte schließen Sie den Vorgang ab.</span>
                </div>
                <div class="contact-wrapper head-w">
                    <span multilang class="head-title mb5">Allgemeine Geschäftsbedingungen</span>
                    <mat-divider></mat-divider>
                    <div class="mt">
                        <mat-checkbox [(ngModel)]="checkDatNor" (change)="datenschutzChangeNor($event)" class="mr">
                        </mat-checkbox>
                        <a multilang (click)="gotoAgbNor()" class="linkified undl">Allgemeine
                            Geschäftsbedingungen</a>
                    </div>
                    <ng-container *ngIf="validErrorDatenschutzNor">
                        <span multilang style="color: red;">Allgemeine Geschäftsbedingungen (Pflichtfeld)</span>
                    </ng-container>
                    <ng-container *ngIf="type === 'chamaeleon'">
                        <div class="mt cent">
                            <mat-checkbox [(ngModel)]="checkDatCh" (change)="datenschutzChangeCh($event)" class="mr">
                            </mat-checkbox>
                            <a multilang (click)="gotoAgbCh()" class="linkified undl">Allgemeine
                                Geschäftsbedingungen
                                der
                                Veranstalters</a>
                        </div>
                        <ng-container *ngIf="validErrorDatenschutzCh">
                            <span multilang style="color: red;">Allgemeine Geschäftsbedingungen der Veranstalters
                                (Pflichtfeld)</span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="type === 'profewo'">
                        <div class="mt cent">
                            <mat-checkbox [(ngModel)]="checkDatPf" (change)="datenschutzChangePF($event)" class="mr">
                            </mat-checkbox>
                            <a multilang (click)="gotoAgbPF()" class="linkified undl">Allgemeine
                                Geschäftsbedingungen
                                der
                                Veranstalters</a>
                        </div>
                        <ng-container *ngIf="validErrorDatenschutzPF">
                            <span multilang style="color: red;">Allgemeine Geschäftsbedingungen der Veranstalters
                                (Pflichtfeld)</span>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="contact-wrapper head-w">
                    <span multilang class="head-title mb5">Datenschutz</span>
                    <mat-divider></mat-divider>
                    <div class="mt checkB">
                        <mat-checkbox [(ngModel)]="checkDat" (change)="datenschutzChange($event)" class="mr">
                        </mat-checkbox>
                        <span multilang>
                            Mit dem Senden der Daten stimmen Sie zu, dass Ihre Informationen an das Reisebüro
                            übermittelt
                            werden und für die Zwecke der Buchung verarbeitet und gespeichert werden. Diese
                            Informationen gemäß der Datenschutzrichtlinie DSGVO zu
                            verwenden. Bitte beachten Sie hierzu unsere Hinweise zur Verarbeitung, Speicherung und
                            Übermittlung Ihrer Daten sowie Ihren Rechten als Betroffener, insbesondere Ihres
                            Widerspruchsrechtes, in der <a multilang (click)="gotoDat()"
                                class="linkified undl">Datenschutzerklärung.</a>
                        </span>
                    </div>
                    <ng-container *ngIf="validErrorDatenschutz">
                        <span multilang style="color: red;">Datenschutzerklärung (Pflichtfeld)</span>
                    </ng-container>
                </div>
            </ng-container>

            <div class="btn-wrapper head-w">
                <ng-container *ngTemplateOutlet="btnSection"></ng-container>
            </div>
            <ng-container *ngIf="step !== 2; else lastI">
                <span multilang class="mt fpadlr">Bitte vervollständigen Sie die fehlenden Angaben in den rot
                    markierten
                    Feldern,
                    die
                    wir
                    zur weiteren Bearbeitung benötigen.</span>
            </ng-container>
        </div>

        <ng-container *ngIf="!mobileMode">
            <div class="right-section">
                <ng-container *ngTemplateOutlet="angebotInfo"></ng-container>
            </div>
        </ng-container>

    </div>
</ng-container>


<ng-template #lastI>
    <span multilang class="mt fpadlr">
        Zu dieser Reise fehlen die Informationen zum neuen Reiserecht (Formblatt) und/oder die AGB des
        Reiseveranstalters. Sie können uns die Buchung jedoch als unverbindliche Anfrage senden. Wir
        kontaktieren Sie um die Buchung für Sie rechtsverbindlich machen.
    </span>
</ng-template>

<div class="fixedlefttop">
    <b>Angebot {{id}}</b>
</div>

<ng-container *ngIf="step !== 3">
    <div class="fixedrighttop">
        <button class="rbtn" (click)="retour($event)">
            <mat-icon>arrow_back_ios</mat-icon>
            <span multilang>Zum Detail</span>
        </button>
    </div>
</ng-container>

<ng-template #kundedaten>
    <div class="sub-header head-w head-title">
        <span multilang>Teilen Sie uns für Ihre Anfrage zu <b>Angebot {{id}}</b> gerne weitere Informationen
            mit.</span>
    </div>

    <div class="contact-wrapper head-w">
        <span multilang class="head-title">Kontaktdaten</span>

        <span multilang class="mt mb5">Bitte geben Sie hier Ihre Daten ein.</span>
        <mat-divider></mat-divider>
        <div class="d-inputs">
            <ng-container *ngIf="profileForm && travelersForm" [ngTemplateOutlet]="myForm"></ng-container>
        </div>
    </div>
    <div class="zahlung-wrapper head-w">
        <ng-container *ngTemplateOutlet="zahlung"></ng-container>
    </div>
</ng-template>

<ng-template #myForm>
    <clever-anmeldungsform [profileForm]="profileForm" [asTouched]="asTouched" [step]="step" [forms]="forms"
        [travelersForm]="travelersForm" (sendStep)="updateStep($event)"></clever-anmeldungsform>
</ng-template>

<ng-template #angebotInfo>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'chamaeleon'">
            <clever-chamaeleon-mini-detail [datas]="datas"></clever-chamaeleon-mini-detail>
        </ng-container>
        <ng-container *ngSwitchCase="'getyourguide'">
            <clever-getyourguide-mini-detail [datas]="datas"></clever-getyourguide-mini-detail>
        </ng-container>
        <ng-container *ngSwitchCase="'profewo'">
            <clever-profewo-mini-detail [datas]="datas"></clever-profewo-mini-detail>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <clever-flight-mini-detail [datas]="datas"></clever-flight-mini-detail>
        </ng-container>
    </ng-container>

</ng-template>

<ng-template #zahlung>
    <span multilang class="head-title">Zahlungsarten</span>
    <span multilang class="mt mb5">
        Hinterlegen Sie Ihren Zahlungswunsch
        <br>
        <br>
        Die Zahlungsarten und -bedingungen können je Leistungsträger/Reiseveranstalter variieren, beachten Sie
        hierzu bitte die AGB der Leistungsträger/Reiseveranstalter. Ihr Reiseveranstalter informiert Sie nach der
        Buchung über die Konditionen.
    </span>
    <mat-divider></mat-divider>
    <span multilang class="mt mb5">Bitte wählen Sie Ihre bevorzugte Zahlungsart</span>

    <ng-container *ngIf="step === 0, else checkMode">
        <mat-form-field appearance="fill" color="primary" style="width: 100%;">
            <mat-select [(ngModel)]="payType">
                <mat-option value="nach telefonischer Rücksprache">nach telefonischer Rücksprache</mat-option>
                <mat-option value="per Überweisung">per Überweisung</mat-option>
                <mat-option value="per Lastschrift">per Lastschrift</mat-option>
                <mat-option value="per Kreditkarte">per Kreditkarte</mat-option>
                <mat-option value="per Rechnung">per Rechnung</mat-option>
                <mat-divider></mat-divider>
            </mat-select>
            <mat-label multilang>Zahlungsarten</mat-label>
        </mat-form-field>

        <ng-container *ngIf="payType === 'per Lastschrift'">
            <from [formGroup]="zahlungForm" class="w100">
                <mat-form-field appearance="fill" color="primary" class="w100">
                    <mat-label multilang>Kontoinhaber</mat-label>
                    <input matInput multilang deeplMode='placeholder' placeholder="Kontoinhaber" name="kontoinhaber"
                        formControlName="kontoinhaber" required>
                    <mat-error multilang>Kontoinhaber (Pflichtfeld)</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary" class="w100">
                    <mat-label multilang>Name der Bank</mat-label>
                    <input matInput multilang deeplMode='placeholder' placeholder="Name der Bank" name="bankName"
                        formControlName="bankName" required>
                    <mat-error multilang>Name der Bank (Pflichtfeld)</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary" class="w100">
                    <mat-label multilang>IBAN</mat-label>
                    <input matInput multilang deeplMode='placeholder' placeholder="IBAN" name="iban"
                        formControlName="iban" required>
                    <mat-error multilang>IBAN (Pflichtfeld)</mat-error>
                </mat-form-field>
                <mat-form-field appearance="fill" color="primary" class="w100">
                    <mat-label multilang>BIC</mat-label>
                    <input matInput multilang deeplMode='placeholder' placeholder="BIC" name="bic" formControlName="bic"
                        required>
                    <mat-error multilang>BIC (Pflichtfeld)</mat-error>
                </mat-form-field>
            </from>
        </ng-container>
    </ng-container>

</ng-template>

<ng-template #checkMode>
    <div class="check-wrapper mt">
        <span multilang>{{payType}}</span>
        <ng-container *ngIf="payType === 'per Lastschrift'">
            <span multilang>{{zahlungForm.controls['kontoinhaber'].value}}</span>
            <span multilang>{{zahlungForm.controls['bankName'].value}}</span>
            <span multilang>{{zahlungForm.controls['iban'].value}}</span>
            <span multilang>{{zahlungForm.controls['bic'].value}}</span>
        </ng-container>
        <div class="mt mb5">
            <button class="btnC" (click)="updateStep(0)">ÄNDEREN</button>
        </div>
    </div>
</ng-template>

<ng-template #btnSection>
    <ng-container *ngIf="(step === 1 || step === 2) else empty">
        <button class="f-b-top" matRipple (click)="updateStep((step === 2 ? 1 : 0))">
            <mat-icon>chevron_left</mat-icon>
            <span multilang>Zurück</span>
        </button>
    </ng-container>
    <ng-container *ngIf="(step === 0 || step === 1) else sendnbtn">
        <button class="f-b-top" matRipple (click)="updateStep((step === 1 ? 2 : 1))">
            <span multilang>Weiter</span>
            <mat-icon>chevron_right</mat-icon>
        </button>
    </ng-container>
</ng-template>

<ng-template #sendnbtn>
    <ng-container *ngIf="!sendEmailLoading else myloading">
        <button class="f-b-top" matRipple (click)="sendAnfrag()">
            <span multilang>{{(type === 'chamaeleon' || type === 'profewo') ? 'Zahlungspflichtig bestellen' :
                'Anfrage
                senden'}}</span>
        </button>
    </ng-container>
</ng-template>

<ng-template #empty>
    <div></div>
</ng-template>

<ng-template #myloading>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>

<ng-template #sendedTemplate>
    <div class="sendungwrapper">
        <ng-container *ngIf="sendungresult else sendungerror">
            <mat-icon class="sendungsuccessicon" fontIcon="verified"></mat-icon>
            <span multilang style="font-size: 2rem;margin-top: 2rem;">Sehr
                {{profileForm?.controls['anmelder_anrede'].value ===
                'Herr' ? 'geehrter' : 'geehrte'}} {{profileForm?.controls['anmelder_anrede'].value + ' ' +
                profileForm?.controls['anmelder_vorname'].value + ' ' +
                profileForm?.controls['anmelder_name'].value}}</span>
            <span multilang style="font-size: 1rem;margin-top: 2rem;">Vielen Dank — Ihre Anmeldung für das
                <b>Angebot
                    {{id}}</b>
                der Beratung <b>{{packid}}</b> wurde erfolgreich übermittelt!</span>


            <span multilang class="sendungMsg">
                Wir werden uns umgehend innerhalb unserer Geschäftszeiten mit Ihnen in Verbindung setzen.
                Die Gültigkeit dieses Angebots kann sich zwischenzeitlich verändert haben.
                Für das endgültige Zustandekommen der Buchung ist die Reisebestätigung des Reisebüros oder des
                Reiseveranstalters relevant.
            </span>


            <span multilang style="font-size: 1rem;margin-top: 1rem;">
                Eine Bestätigungs-E-Mail wurde an <b>{{profileForm?.controls['anmelder_email'].value}}</b> versandt.
            </span>
            <span multilang style="font-size: 1rem;margin-top: 2rem;">Ihr Berater {{mitName}}.</span>
        </ng-container>
    </div>
</ng-template>


<ng-template #sendungerror>
    <mat-icon class="sendungerroricon">new_releases</mat-icon>

    <span multilang style="font-size: 2rem;margin-top: 2rem;line-height: 2rem;text-align: center;">Bei Rückfragen
        kontaktieren sie
        uns bitte unter {{mitTel}}</span>

    <div class="fer-error-primary">
        <mat-icon style="margin-right: 0.3rem;">notification_important</mat-icon>
        <span multilang>
            {{sengungrormessage}}
        </span>
    </div>

    <span multilang style="font-size: 1rem;margin-top: 2rem;text-align: center;">Wir wünschen Ihnen eine angenehme
        Reise
        und
        hoffen Sie bald
        wiederzusehen.</span>
    <span multilang style="font-size: 1rem;margin-top: 2rem;">Ihr Berater {{mitName}}</span>
</ng-template>